import React from 'react';

import EdiUpload from 'components/LM/Voice/MassImport/Upload';
import DetailStatus from 'components/LM/Voice/MassImport/status/DetailStatus';
import OverallStatus from 'components/LM/Voice/MassImport/status/OverallStatus';
import BssoPermissions from "components/LM/Bsso/Permissions";

function MassImportView(props) {
	return (<BssoPermissions permissions={['voices']} behaviour="error">
		<EdiLoader {...props} />
	</BssoPermissions>)
}

function EdiLoader(props) {
	const locationPathname = props.location.pathname;
	if (locationPathname === "/voices/import") return <EdiUpload {...props} />

	if (props.match.params.identifier) return <DetailStatus id={props.match.params.identifier} {...props} />;
	return <OverallStatus {...props} />;
}

export default MassImportView;
